import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46727235"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-wrap" }
const _hoisted_2 = { class: "news" }
const _hoisted_3 = { class: "news-content-block margin-l-r" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iframe-container" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    class: "video-container",
    width: "100%",
    height: "100%",
    src: "https://www.youtube.com/embed/AehvFKjFBCE?si=GiAAB4yR_eVs9zkQ",
    title: "YouTube video player",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowfullscreen: ""
  }, "\r\n          ")
], -1))
const _hoisted_5 = {
  class: "news-content-block-sub-title",
  style: {"margin-top":"30px","margin-bottom":"30px","font-size":"16px","color":"#4F5E74"}
}
const _hoisted_6 = {
  class: "news-content-block-sub-title",
  style: {"margin-top":"30px","margin-bottom":"30px","font-size":"16px"}
}
const _hoisted_7 = {
  class: "news-content-block-sub-title",
  style: {"margin-top":"30px","margin-bottom":"30px","font-size":"16px"}
}
const _hoisted_8 = {
  class: "news-content-block-sub-title",
  style: {"margin-top":"30px","margin-bottom":"30px","font-size":"16px","font-weight":"bold"}
}
const _hoisted_9 = {
  class: "news-content-block-sub-title",
  style: {"font-size":"16px"}
}
const _hoisted_10 = {
  class: "news-content-block-sub-title",
  style: {"font-size":"16px"}
}
const _hoisted_11 = {
  class: "news-content-block-sub-title",
  style: {"font-size":"16px"}
}
const _hoisted_12 = {
  class: "news-content-block-sub-title",
  style: {"margin-top":"30px","margin-bottom":"30px","font-size":"16px","font-weight":"bold"}
}
const _hoisted_13 = {
  class: "news-content-block-sub-title",
  style: {"font-size":"16px"}
}
const _hoisted_14 = {
  class: "news-content-block-sub-title",
  style: {"font-size":"16px"}
}
const _hoisted_15 = {
  class: "news-content-block-sub-title",
  style: {"margin-top":"30px","margin-bottom":"30px","font-size":"16px","font-weight":"bold"}
}
const _hoisted_16 = {
  class: "news-content-block-sub-title",
  style: {"font-size":"16px"}
}
const _hoisted_17 = {
  class: "news-content-block-sub-title",
  style: {"font-size":"16px"}
}
const _hoisted_18 = {
  class: "news-content-block-sub-title",
  style: {"font-size":"16px"}
}
const _hoisted_19 = {
  class: "news-content-block-sub-title",
  style: {"margin-top":"30px","margin-bottom":"30px","font-size":"16px"}
}
const _hoisted_20 = {
  class: "news-content-block-sub-title",
  style: {"margin-top":"30px","margin-bottom":"30px","font-size":"16px"}
}
const _hoisted_21 = {
  class: "news-content-block-sub-title",
  style: {"margin-top":"30px","margin-bottom":"30px","font-size":"16px"}
}
const _hoisted_22 = { class: "news-content-block-image" }

import {WrapTitle} from "../../entities";
import {NewsContent} from "../../widgets";
import {news_8_img, useDataStore, useLocalizationStore} from "../../shared";
import {onMounted} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'news-eight-page',
  setup(__props) {

const {translate} = useLocalizationStore();
const {scrollTop} = useDataStore();

onMounted(() => {
  scrollTop();
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(WrapTitle), {
          text: _unref(translate)('news_8_title'),
          class: "news-content-block-wrap-title",
          size: "regular",
          weight: "700"
        }, null, 8, ["text"]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(translate)("news_8_body_p1")), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(translate)("news_8_body_p2")), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(translate)("news_8_body_p3")), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)("news_8_body_p4")), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(translate)("news_8_body_p5")), 1),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translate)("news_8_body_p6")), 1),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(translate)("news_8_body_p7")), 1),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(translate)("news_8_body_p8")), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(translate)("news_8_body_p9")), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(translate)("news_8_body_p10")), 1),
        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(translate)("news_8_body_p11")), 1),
        _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(translate)("news_8_body_p12")), 1),
        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(translate)("news_8_body_p13")), 1),
        _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(translate)("news_8_body_p14")), 1),
        _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(translate)("news_8_body_p16")), 1),
        _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(translate)("news_8_body_p17")), 1),
        _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(translate)("news_8_body_p18")), 1),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_v_img, {
            class: "w-100",
            src: require('@/shared/assets/images/new/news_8_img.svg'),
            "aspect-ratio": undefined
          }, null, 8, ["src"])
        ])
      ]),
      _createVNode(_unref(NewsContent), { showSelectedNews: true })
    ])
  ]))
}
}

})